export function withReactHooks(useHooks) {
  return (Component) => {
    const ConnectedComponent = (props) => {
      const extraProps = useHooks();

      return <Component {...props} {...extraProps} />;
    };

    return ConnectedComponent;
  };
}
